/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_Zedonk_LegacyInputs */

const en_mapping_system_zedonk_legacy = /** @type {(inputs: Mapping_System_Zedonk_LegacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zedonk (legacy)`)
};

/**
* | output |
* | --- |
* | "Zedonk (legacy)" |
*
* @param {Mapping_System_Zedonk_LegacyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_zedonk_legacy = /** @type {((inputs?: Mapping_System_Zedonk_LegacyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_Zedonk_LegacyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_zedonk_legacy(inputs)
});